import { render, staticRenderFns } from "./ExcelCreateButton.vue?vue&type=template&id=496810f7&"
import script from "./ExcelCreateButton.vue?vue&type=script&lang=ts&"
export * from "./ExcelCreateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports